import { FeatureAccessValue, usePlanFeatureGate } from './use-plan-feature-gate';
import { Features } from '../constants/features';
import { useIsSellerFeatureEnabled } from '../hooks/use-is-seller-feature-enabled';

/** @typedef {import('../prop-types/intl-types').MessageDescriptor} MessageDescriptor */
/** @typedef {import('./use-plan-feature-gate').FeatureAccessValueType} FeatureAccessValueType */

/**
 * Is the BYOA feature availabe to the user
 * @returns {{ isFeatureEnabled: boolean, disabledMessage?: MessageDescriptor, shouldHide?: boolean }}
 */
export const useNonWalletProviderFeatureGate = () => {
  const sellerAlreadyHasFeature = useIsSellerFeatureEnabled(Features.NonWalletProviderAccess);
  const defaultSellerFeatureAccessValue = sellerAlreadyHasFeature ? FeatureAccessValue.Enabled : FeatureAccessValue.Disabled;

  return usePlanFeatureGate(Features.NonWalletProviderAccess, defaultSellerFeatureAccessValue);
};

export { FeatureAccessValue };
